import { gql } from "@apollo/client";

export const GET_ALL_IPS_VIOLATIONS = gql`
  query getIpsViolations {
    getIpsViolations {
      ipsPointId
      ipsPoints
      returnToComplianceMethod
      lastUpdateDate
      lastUpdateUser
      analyteId
      analyteName
      analyteLabel
      analyteValue
      isGrpAnalyte
      violationId
      violationStCode
      violationName
      anlytGrpId
      anlytGrpName
      anlytGrpCode
      reportId
      reportName
      ruleName
    }
  }
`;

export const GET_ALL_VIOLATION_TYPES = gql`
  query getAllViolationTypes {
    getAllViolationTypes {
      violationId
      violationName
      violationStCode
    }
  }
`;

export const GET_ALL_ANALYTES = gql`
  query getAllAnalytes {
    getAllAnalytes {
      analyteId
      analyteCode
      analyteName
    }
  }
`;

export const GET_ALL_SECTIONS = gql`
  query getAllViolationSections {
    getAllViolationSections {
      value
      label
    }
  }
`;

export const GET_ALL_ANALYTE_GROUPS = gql`
  query getAllAnalyteGroups {
    getAllAnalyteGroups {
      groupId
      groupCode
      groupName
    }
  }
`;

export const GET_GROUP_ANALYTES = gql`
  query getAnalytesByGroupId($groupId: Int) {
    getAnalytesByGroupId(groupId: $groupId) {
      analyteId
      analyteCode
      analyteName
      groupId
      groupCode
    }
  }
`;

export const ADD_NEW_VIOLATIONS = gql`
  mutation addIpsViolation(
    $ipsPoints: Int
    $returnToComplianceMethod: String
    $lastUpdateUser: String!
    $lastUpdateDate: Date
    $analyteId: Int
    $analyteLabel: String!
    $analyteValue: Int!
    $isGrpAnalyte: Boolean!
    $violationId: Int!
    $violationStCode: String!
    $reportId: Int
    $anlytGrpId: Int
    $ruleName: String!
  ) {
    addIpsViolation(
      AddIpsViolationInput: {
        returnToComplianceMethod: $returnToComplianceMethod
        ipsPoints: $ipsPoints
        lastUpdateUser: $lastUpdateUser
        lastUpdateDate: $lastUpdateDate
        analyteId: $analyteId
        analyteLabel: $analyteLabel
        analyteValue: $analyteValue
        isGrpAnalyte: $isGrpAnalyte
        violationId: $violationId
        violationStCode: $violationStCode
        reportId: $reportId
        anlytGrpId: $anlytGrpId
        ruleName: $ruleName
      }
    ) {
      ipsPointId
      ipsPoints
      returnToComplianceMethod
      lastUpdateDate
      lastUpdateUser
      analyteId
      analyteName
      analyteLabel
      analyteValue
      isGrpAnalyte
      violationId
      violationStCode
      violationName
      anlytGrpId
      ruleName
    }
  }
`;

export const UPDATE_VIOLATION = gql`
  mutation updateIpsViolation(
    $ipsPointId: Int!
    $ipsPoints: Int
    $returnToComplianceMethod: String
    $lastUpdateUser: String!
    $lastUpdateDate: Date
    $reportId: Int
    $ruleName: String!
  ) {
    updateIpsViolation(
      UpdateIpsViolationInput: {
        ipsPointId: $ipsPointId
        returnToComplianceMethod: $returnToComplianceMethod
        ipsPoints: $ipsPoints
        lastUpdateUser: $lastUpdateUser
        lastUpdateDate: $lastUpdateDate
        reportId: $reportId
        ruleName: $ruleName
      }
    ) {
      ipsPointId
      ipsPoints
      returnToComplianceMethod
      lastUpdateDate
      lastUpdateUser
      analyteId
      analyteLabel
      analyteValue
      isGrpAnalyte
      analyteName
      violationId
      violationName
      ruleName
      reportId
    }
  }
`;

export const DELETE_VIOLATION = gql`
  mutation deleteIpsViolation($ipsPointId: Int!) {
    deleteIpsViolation(DeleteIpsViolationInput: { ipsPointId: $ipsPointId }) {
      ipsPointId
      ipsPoints
      returnToComplianceMethod
      lastUpdateDate
      lastUpdateUser
      analyteId
      analyteLabel
      analyteValue
      isGrpAnalyte
      analyteName
      violationId
      violationName
    }
  }
`;
